import React, { useState } from 'react';
import { clsx } from 'clsx';
import SafeIcon from '../common/SafeIcon';

export const GlassNavbar = ({ items = [], className }) => {
  const [active, setActive] = useState(0);

  return (
    <nav className={clsx('glass-navbar', className)}>
      {items.map((item, i) => (
        <button
          key={i}
          onClick={() => { setActive(i); item.onClick?.(i); }}
          className={clsx(
            'glass-navbar__item',
            active === i && 'glass-navbar__item--active'
          )}
        >
          {item.icon && <SafeIcon icon={item.icon} className="glass-navbar__icon" />}
          <span>{item.label}</span>
        </button>
      ))}
    </nav>
  );
};

export default GlassNavbar;
